import { default as packageJson } from '../package.json';

export const title = packageJson.title;

export const version = packageJson.version;

/**
 * @type {String} 'localStorage' | 'sessionStorage'
 * @description Storage for user settings and sessions.
 */
export const storage = 'localStorage';

/**
 * @type {String} 'vue_'
 * @description Key prefix for data in storage.
 */
export const prefix = 'yta_';

/**
 * @type %{number} 604800
 * @description User session storage time in seconds.
 * Default 7 days
 */
export const ttl = 7 * 24 * 3600;

/**
 * @type {Object}
 * @description Default application settings.
 */
export const settings = {
	locale: 'vi', // language config
	dense: true,
	footer: false,
	navbar: {
		show: true,
		dense: true,
		logo: false,
		width: 56,
		clipped: false, // clipped false side bar full height
	},
	fullscreen: {
		show: false,
		btn: true,
	},
	settingsPanel: {
		show: false,
		btn: true,
	},
	theme: {
		index: 0,
		dark: false,
	},
};
